import React from 'react';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import AttachMoneyRoundedIcon from '@mui/icons-material/AttachMoneyRounded';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import styles from './HeroSection.module.css';
import OwnNumberNote from '../shared/OwnNumberNote';
import { trackCtaClick } from '../../../../utils/analytics';
import mockupImg from '../../../../assets/images/lp/home.png';

// Ícone de check idêntico ao usado nos cards de planos da landing page
const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="8" fill="#5a80fb" fillOpacity="0.12"/>
    <path d="M4.5 8L7 10.5L11.5 6" stroke="#5a80fb" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Ícone calendário (card 1 — Novo agendamento)
const CalendarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="16" y1="2" x2="16" y2="6" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round"/>
    <line x1="8" y1="2" x2="8" y2="6" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round"/>
    <line x1="3" y1="10" x2="21" y2="10" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round"/>
  </svg>
);

// Ícone usuários (card 2 — Pacientes ativos)
const UsersIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0EA5E9" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);

// Ícone WhatsApp (card 3 — Lembrete pronto, um clique abre o WhatsApp Web)
const WhatsAppIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="#25D366" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>
  </svg>
);

// Ícone nota fiscal — documento com check (card 4 — Nota fiscal emitida)
const InvoiceIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#059669" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
    <polyline points="9 15 11 17 15 13"/>
  </svg>
);

// Ícone estrela (card 5 — Nova recomendação)
const StarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#7C3AED" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
  </svg>
);

const FEATURES = [
 "Agenda organizada e sem conflitos",
"Pacientes, prontuários e documentos em um só lugar",
"Financeiro e indicadores sempre à mão",
"Confirmações e lembretes prontos em um clique ou automáticos*",
];

function HeroSection({
  onScrollToBeta,
  imageSrc = null
}) {

  return (
    <>
      {/* ── DESKTOP HERO ── */}
      <section id="inicio" className={`${styles.heroSection} ${styles.heroDesktopOnly}`}>
        <img src={imageSrc} alt="Screenshot do sistema Gabriela" className={styles.screenshotImage} />
        <div className={styles.heroOverlay}>
          <div className={styles.heroTextContent}>
            <h2 className={styles.heroTitle}>
              Mais organização para o seu dia.<br/>Mais tempo para o que importa.
            </h2>
            <p className={styles.heroSubtitle}>
              A Gabriela reúne agenda, pacientes, prontuários, documentos, financeiro e comunicação em um só lugar, para você trabalhar com mais tranquilidade e controle.
            </p>
            <ul className={styles.featureList}>
              {FEATURES.map((feature) => (
                <li key={feature} className={styles.featureItem}>
                  <CheckIcon />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
            <button className={styles.ctaButton} onClick={() => {
              trackCtaClick({ placement: 'hero_primary_cta' });
              onScrollToBeta();
            }}>
              Testar grátis por 30 dias
            </button>
            <OwnNumberNote className={styles.heroNote} />
          </div>
        </div>

        {/* ── Floating Cards — lado direito da hero ── */}
        <div className={styles.floatingCardsArea} aria-hidden="true">

          {/* Card 1 — Novo agendamento */}
          <div className={`${styles.floatingCard} ${styles.card1}`}>
            <div className={styles.cardIconWrap} style={{ background: 'rgba(59, 130, 246, 0.12)' }}>
              <CalendarIcon />
            </div>
            <div className={styles.cardContent}>
              <span className={styles.cardTitle}>Novo agendamento</span>
              <span className={styles.cardSub}>Maria S. · Hoje às 14h30</span>
              <span className={styles.cardBadgeGreen}>Confirmado</span>
            </div>
          </div>

          {/* Card 2 — Pacientes ativos */}
          <div className={`${styles.floatingCard} ${styles.card2}`}>
            <div className={styles.cardIconWrap} style={{ background: 'rgba(14, 165, 233, 0.12)' }}>
              <UsersIcon />
            </div>
            <div className={styles.cardContent}>
              <span className={styles.cardTitle}>Pacientes ativos</span>
              <span className={styles.cardValue}>1.247</span>
              <span className={styles.cardSub}>+23 este mês</span>
            </div>
          </div>

          {/* Card 3 — Lembrete pronto: a pessoa clica e o WhatsApp Web abre com a mensagem */}
          <div className={`${styles.floatingCard} ${styles.card3}`}>
            <div className={styles.cardIconWrap} style={{ background: 'rgba(37, 211, 102, 0.12)' }}>
              <WhatsAppIcon />
            </div>
            <div className={styles.cardContent}>
              <span className={styles.cardTitle}>Lembrete pronto</span>
              <span className={styles.cardSub}>João M. · amanhã às 10h</span>
              <span className={styles.cardAction}>Abrir no WhatsApp</span>
            </div>
          </div>

          {/* Card 4 — Nota fiscal emitida */}
          <div className={`${styles.floatingCard} ${styles.card4}`}>
            <div className={styles.cardIconWrap} style={{ background: 'rgba(5, 150, 105, 0.12)' }}>
              <InvoiceIcon />
            </div>
            <div className={styles.cardContent}>
              <span className={styles.cardTitle}>Nota fiscal emitida</span>
              <span className={styles.cardSub}>NFS-e enviada com sucesso · agora</span>
              <span className={styles.cardBadgeGreen}>Enviada</span>
            </div>
          </div>

          {/* Card 5 — Nova recomendação */}
          <div className={`${styles.floatingCard} ${styles.card5}`}>
            <div className={styles.cardIconWrap} style={{ background: 'rgba(124, 58, 237, 0.12)' }}>
              <StarIcon />
            </div>
            <div className={styles.cardContent}>
              <span className={styles.cardTitle}>Lista de espera</span>
              <span className={styles.cardSub}>Horário vago preenchido pela lista de espera</span>
            </div>
          </div>

        </div>
      </section>

      {/* ── MOBILE HERO ── */}
      <div className={styles.heroMobileOnly}>
        {/* Imagem de fundo com gradiente */}
        <div className={styles.mobileHeroBg}>
          <img src={imageSrc} alt="" className={styles.mobileHeroBgImg} />
          <div className={styles.mobileHeroGradient} />
        </div>

        {/* Conteúdo */}
        <div className={styles.mobileHeroContent}>
          {/* Badge único */}
          <div className={styles.mobileChips}>
            <span className={styles.mobileChip}>Para profissionais que atendem pessoas</span>
          </div>

          {/* Título */}
          <h1 className={styles.mobileHeroTitle}>
            Mais organização para o seu dia.{' '}
            <span className={styles.mobileHeroHighlight}>Mais tempo para o que importa.</span>
          </h1>

          {/* Subtítulo */}
          <p className={styles.mobileHeroSubtitle}>
            A Gabriela reúne agenda, pacientes, prontuários, documentos, financeiro e comunicação em um só lugar, para você trabalhar com mais tranquilidade e controle.
          </p>

          {/* CTA */}
          <button className={styles.mobileHeroCta} onClick={() => {
            trackCtaClick({ placement: 'hero_mobile_cta' });
            onScrollToBeta();
          }}>
            Testar grátis por 30 dias →
          </button>
          <p className={styles.mobileHeroCtaNote}>Sem cartão de crédito • Cancele quando quiser</p>

          {/* Mockup com floating cards */}
          <div className={styles.mobileHeroMockupArea}>
            <img src={mockupImg} alt="App Gabriela" className={styles.mobileHeroMockup} />

            {/* Floating card 1 - Confirmação */}
            <div className={`${styles.mobileFloatingCard} ${styles.mobileFloatingCard1}`}>
              <div className={styles.mobileFloatingCardIcon}><CheckRoundedIcon fontSize="inherit" /></div>
              <div>
                <div className={styles.mobileFloatingCardTitle}>Horário confirmado</div>
                <div className={styles.mobileFloatingCardSub}>Ana C. P. Muniz confirmou pelo link</div>
              </div>
            </div>

            {/* Floating card 2 - Faturamento */}
            <div className={`${styles.mobileFloatingCard} ${styles.mobileFloatingCard2}`}>
              <div className={styles.mobileFloatingCardIcon}><AttachMoneyRoundedIcon fontSize="inherit" /></div>
              <div>
                <div className={styles.mobileFloatingCardTitle}>Faturamento do dia</div>
                <div className={styles.mobileFloatingCardValue}>R$ 3.450,00</div>
                <div className={styles.mobileFloatingCardGrowth}>+12% vs ontem</div>
              </div>
            </div>

            {/* Floating card 3 - Lembrete pronto, um clique abre o WhatsApp Web */}
            <div className={`${styles.mobileFloatingCard} ${styles.mobileFloatingCard3}`}>
              <div className={styles.mobileFloatingCardIcon}><NotificationsNoneOutlinedIcon fontSize="inherit" /></div>
              <div>
                <div className={styles.mobileFloatingCardTitle}>Lembrete pronto</div>
                <div className={styles.mobileFloatingCardSub}>João M. • amanhã às 10h</div>
                <div className={styles.mobileFloatingCardAction}>Abrir no WhatsApp</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HeroSection;
